<template>
  <div class="app-container">
    <!-- 页面内容 -->
    <div class="container-page">
      <el-form :model="formData" :rules="rulesForm" ref="ruleForm" label-width="140px">
        <!-- 第一部分 -->
        <div class="title-box">
          <h2 class="title">基本信息</h2>
        </div>
        <div>
          <!-- 需求编号 -->
          <!-- <el-form-item class="form-item form-inline-item" label="需求编号">
                        <el-input v-model="formData.number" disabled style="width:240px"></el-input>
                    </el-form-item> -->

          <!-- 需求发起日期 -->
          <el-form-item class="form-item form-inline-item" label="需求发起日期">
            <el-date-picker v-model="formData.createTimeStr" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled style="width:240px"></el-date-picker>
          </el-form-item>
        </div>

        <!-- 需求人 -->
        <el-form-item class="form-item" label="需求人">
          <el-input v-model="formData.createUserName" disabled style="width:240px"></el-input>
        </el-form-item>

        <!-- 需求部门 -->
        <el-form-item class="form-item" label="需求部门" prop="departmentId" ref="departmentId">
          <el-select v-model="formData.departmentId" placeholder="请选择" style="width:240px">
            <el-option v-for="item in departmentOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- 需求标题 -->
        <el-form-item class="form-item" label="需求标题" prop="title" ref="title">
          <el-input v-model="formData.title" style="width:240px" placeholder="20字以内" :maxlength="20" type='text'></el-input>
        </el-form-item>

        <!-- 项目名称 -->
        <el-form-item class="form-item" label="项目名称" prop="projectId" ref="projectId">
          <el-select v-model="formData.projectId" filterable  placeholder="请选择" style="width:240px">
            <el-option v-for="item in gameOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- 计划时间点 -->
        <el-form-item class="form-item" label="计划时间点" prop="plan" ref="plan">
          <!-- <el-date-picker unlink-panels  v-model="formData.plan" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:340px"></el-date-picker> -->
          <div style="display:flex;align-items:center">
          <el-date-picker v-model="formData.plan[0]" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  placeholder="开始日期" class="dateClass" >
          </el-date-picker>
          <div style="display:inline-block;margin:0 12px;">
              <span style="display:block;width:9px;height:2px;background:#666"></span>
          </div>
          <el-date-picker v-model="formData.plan[1]" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  placeholder="完稿日期" class="dateClass">
          </el-date-picker>
          </div>
          
        </el-form-item>

        <!-- 预算总金额 -->
        <el-form-item class="form-item" label="预算总金额" prop="budgetAmount" ref="budgetAmount">
          <div class="select-item">
            <el-select v-model="formData.budgetCurrency" slot="prepend" placeholder="请选择">
              <el-option v-for="item in currencyOptions" :key="item.label" :label="item.label" :value="item.label"></el-option>
            </el-select>
            <el-input-number placeholder="请输入" v-model="formData.budgetAmount" controls-position="right" :precision="2" :min="0"></el-input-number>
            <span class="text">元</span>
          </div>
        </el-form-item>

        <!-- 预算所需工时 -->
        <el-form-item class="form-item" label="预算所需工时" prop="workingDays" ref='workingDays'>
          <div class="select-item input-item">
            <el-input-number placeholder="请输入" v-model="formData.workingDays" controls-position="right" :precision="1" :step="0.1"></el-input-number>
            <span class="text">工作日</span>
          </div>
        </el-form-item>

        <div class="line"></div>
        <!-- 第二部分 -->
        <div class="title-box">
          <h2 class="title">设计信息</h2>
        </div>

        <!-- 设计类型 -->
        <el-form-item class="form-item" label="设计类型" prop="designTypeId" ref="designTypeId">
          <!-- <el-select v-model="formData.designTypeId" placeholder="请选择">
                        <el-option v-for="item in designTypeOptions" :key="item.value" :label="item.label" :value="item.value" style="width:240px"></el-option>
                    </el-select> -->

          <el-cascader collapse-tags v-model="formData.designTypeId" :options="designTypeOptions" :props="{ multiple: true, expandTrigger: 'hover' ,label:'name', value:'id', children:'childs'}" filterable clearable class="triangleClass" placeholder="请选择" style="width:300px"></el-cascader>

        </el-form-item>

        <!-- 需求详述 -->
        <el-form-item label="需求详述" prop="requirementDescription" ref="requirementDescription">
          <markdown-editor v-model="formData.requirementDescription" mode="wysiwyg" language="zh-CN" height="240px" style="width:660px;" />
        </el-form-item>

        <!-- 参考风格例图 -->
        <el-form-item class="form-item" label="参考风格例图">
          <!-- <simple-uploader :isSource="fileChunkUploadUrl" ref="exampleUploader"  @onSuccess="(file, fileList) => handleSuccess(file, fileList, 'referenceFileId')" @onRemove="handleRemove" style="min-width:660px; width:25vw"></simple-uploader> -->
          <advanced-simple-uploader :beforeFileList="beforeReferenceFileDetail" :isSource="fileChunkUploadUrl" ref="exampleUploader"
            @onSuccess="(file, fileList) => handleSuccess(file, fileList, 'referenceFileId')" @onRemove="handleRemove($event, 'referenceFileId')" @onDelete="handleRemove($event,'referenceFileId')"
            style="min-width:660px; width:25vw"></advanced-simple-uploader>
        </el-form-item>

        <div class="line"></div>
        <!-- 第三部分 -->
        <div class="title-box">
          <h2 class="title">甄选外包商</h2>
        </div>

        <!-- 外包商类型 -->
        <el-form-item class="form-item" label="外包商类型" prop="outsourcerType" ref="outsourcerType">
          <el-radio-group v-model="formData.outsourcerType" @change="changeOutsourcerType">
            <el-radio label="61">公司</el-radio>
            <el-radio label="62">个人</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 外包商选择 -->
        <el-form-item class="form-item" label="外包商选择" prop="outsourcerId" ref="outsourcerId">
          <el-select v-model="formData.outsourcerId" filterable placeholder="请选择" style="width:240px">
            <el-option v-for="item of outsourcingOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <div class="line"></div>
        <!-- 第四部分 -->
        <div class="title-box">
          <h2 class="title">上传需求单(需盖章)</h2>
        </div>

        <!-- 上传需求单 -->
        <el-form-item class="form-item" label="上传需求单" prop="requirementFileId" ref="requirementFileId">
         
          <advanced-simple-uploader :beforeFileList="beforeRequirementFileDetail" :maxNum='1' :isSource="fileChunkUploadUrl" source="coop" ref="uploader"
            @onSuccess="(file, fileList) => handleSuccess(file, fileList, 'requirementFileId')" @onRemove="handleRemove($event,'requirementFileId')" @onDelete="handleRemove($event,'requirementFileId')"
            style="min-width:660px; width:25vw"></advanced-simple-uploader>

          <a :href="`${publicPath}设计制作需求单（样式）.xlsx`" class="download">下载需求单模板 <i class="el-icon-arrow-right"></i></a>

        </el-form-item>

        <div class="line"></div>
        <!-- 第五部分 -->
        <div class="title-box">
          <h2 class="title">存储空间选择</h2>
          <el-popover popper-class="gray-popper" placement="right-end" width="260" trigger="hover">
            <div class="text">选择存储空间后，乙方上传的最终完稿文件将自动存储至该空间</div>
            <svg-icon class="icon" icon-class="explain" slot="reference" />
          </el-popover>
        </div>

        <!-- 完稿文件存储空间  invertTriangle-->
        <el-form-item class="form-item" label="完稿文件存储空间" prop="storageFolderId" ref="storageFolderId">
          <el-cascader :props="spaceProps" v-model="formData.storageFolderId" filterable class="triangleClass"></el-cascader>
        </el-form-item>
      </el-form>

      <!-- 底部定位 -->
      <div class="footer-box">
        <div class="check-box">
          <label>通知方式：</label>
          <el-checkbox v-model="checkedEmail">邮箱</el-checkbox>
        </div>
        <!-- <el-button type="primary" plain @click="handleReset">重置</el-button>
                <el-button type="primary" plain @click="saveFun">保存</el-button> -->
        <el-button type="primary" @click="handleSubmit">提交申请</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import SimpleUploader from '../materialCenter/components/simpleUploader.vue'
import advancedSimpleUploader from './components/advancedSimpleUploader.vue'
import { config_departmentList, config_designTypeTree, config_outsourceList, config_folderByMenuIds, config_folderByPid, outsource_flowDetail, outsource_addFlow, outsource_modifyFlow } from '@File~/api/outsourcing'
import { projectList_ajax } from '@File~/api/file'
import store from '@Sys~/store'
import { parseTime } from '@/utils/index.js'
import { deepClone } from '@/utils'
import { apiUrl } from '@File~/api/env' 
export default {
  components: { MarkdownEditor, SimpleUploader, advancedSimpleUploader },

  data() {
    return {
      fileChunkUploadUrl:this.$store.getters.uploadUrl,//apiUrl.fileUrl+"/api/file/fileChunkUpload",
      flowId: '',//为需求变更准备，回显数据
      newOptions: {
        target: apiUrl.fileUrl+"/api/file/fileChunkUpload",// 上传文件地址
        chunkSize: 10 * 1024 * 1024,   //分块大小
        fileParameterName: 'file', //上传文件时文件的参数名，默认file
        simultaneousUploads: 1, // 并发上传数,默认3
        testChunks: true,     //是否开启分片
        checkChunkUploadedByResponse: (chunk, message) => {
          // console.log(chunk.offset)
          let objMessage = JSON.parse(message)
          if (objMessage.skipUpload) { // 秒传
            return true
          }
          return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
        },
        // query:{
        //     fileUuid: Date.now() + '123' + this.$store.getters.userId
        // },
        permanentErrors: [404, 415, 500, 501, 506, 507]
      },
      publicPath: process.env.BASE_URL,
      //存储空间初始化
      spaceProps: {
        label: 'folderName',
        value: 'id',
        leaf: 'status',
        checkStrictly: true,
        expandTrigger: 'hover',
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            let param = []
            //获取当前用户的个人空间
            store.getters.permission_routes.map((item) => {
              if (item.path === '/materialCenter') {
                item.children.forEach(element => {
                  if (element.name === 'team') {
                    for (let i of element.children) {
                      param.push(i.meta.id)
                    }
                  }
                });
              }
            })
            config_folderByMenuIds(param).then(response => {
              response.data.map((item) => {
                item.status = !item.ownChild
              })

              if (response.code == 1) {
                resolve(response.data)
              }
            })

          } else {
            config_folderByPid(node.data.id).then(response => {
              response.data.map((item) => {
                item.status = !item.ownChild
              })

              if (response.code == 1) {
                resolve(response.data)
              }
            })

          }
        }
      },
      beforeReferenceFileDetail: [],
      beforeRequirementFileDetail: [],
      formData: {
        // number:'', // 需求编号
        createTimeStr: '2021-06-28', // 需求发起日期
        departmentId: '', // 部门
        createUserName: '张三', // 需求人
        createUserId: '', // 需求人
        title: '', // 标题
        projectId: '', // 项目
        plan: [], // 计划时间点
        budgetCurrency: '人民币', // 货币类型
        budgetAmount: undefined,//预算金额 需要无默认值

        workingDays: undefined, // 工作日
        designTypeId: '', // 设计类型
        requirementDescription: '', //需求详述
        outsourcerType: '61', // 外包商类型
        outsourcerId: '', // 外包商
        storageFolderId: '', // 完稿文件存储空间

        referenceFileId: [], // 参考图
        requirementFileId: [], // 需求单图
        status: 1
      },
      // 部门
      departmentOptions: [],
      // 游戏项目
      gameOptions: [],
      // 货币类型
      currencyOptions: [
        {
          value: 1,
          label: '人民币'
        },
        {
          value: 2,
          label: '美元'
        },
        {
          value: 3,
          label: '欧元'
        },
        {
          value: 4,
          label: '新台币'
        },
        {
          value: 5,
          label: '港币'
        },
        {
          value: 6,
          label: '日币'
        },
      ],
      // 设计类型
      designTypeOptions: [],
      //外包商
      outsourcingOptions: [],
      // 存储空间
      spaceOptions: [],

      checkedEmail: false,

      // 表单验证
      rulesForm: {
        departmentId: [{ required: true, message: '请选择需求部门', trigger: 'change' }],
      title: [
          { required: true, message: '请输入需求标题', trigger: 'blur' },
          { min: 1, max: 20, message: '20字以内', trigger: 'blur' }
        ],
      projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        plan: [{ required: true, trigger: 'change' ,validator:(rule,value,callback)=>{
            console.log(value)
            console.log(rule)
            if(this.formData.plan.length === 2){
                if(!this.formData.plan[0]){
                        callback('请选择开始日期');
                }
                if(!this.formData.plan[1]){
                    callback('请选择完稿日期')
                }

                if(this.formData.plan[0]&&this.formData.plan[1]){
                    let timeStart = new Date(this.formData.plan[0]).getTime();
                    let timeEnd = new Date(this.formData.plan[1]).getTime();
                    if(timeStart > timeEnd){
                        callback('开始日期应小于完稿日期');
                    }else {
                        callback()
                    }
                 }
            }else{
                callback('请选择完稿日期')
            }
            
        }}],
        budgetAmount: [{ required: true, message: '请输入预算总金额', trigger: 'blur' }],
        workingDays: [{ required: true, message: '请输入预期所需工时', trigger: 'blur' }],
        designTypeId: [{ required: true, message: '请选择设计类型', trigger: 'change' }],
        requirementDescription: [{ required: true, message: '请输入需求详述', trigger: 'blur' }],
        outsourcerId: [{ required: true, message: '请选择外包商', trigger: 'change' }],
        requirementFileId: [{ required: true, message: '请上传外包需求单', trigger: 'change' }],
        storageFolderId: [{ required: true, message: '请选择完稿文件存储空间', trigger: 'change' }]
      }
    }
  },
  async created() {
    this.formData.createTimeStr = parseTime(new Date(), '{y}-{m}-{d}')
    this.formData.createUserName = this.$store.state.user.realName
    this.formData.createUserId = this.$store.state.user.userId
    if (this.$route.query.flowId) {
      this.flowId = window.atob(this.$route.query.flowId) * 1;
      let that = this;
      //await 解决外包商列表加载问题
      await outsource_flowDetail(this.flowId).then((response) => {
        if (response.code == 1) {
          // this.formData = response.data
          for (let item in this.formData) {
            this.formData[item] = response.data[item] ? response.data[item] : this.formData[item]
          }

          this.formData.outsourcerType += '';
          this.formData.plan.push(response.data.planTimeStartStr);
          this.formData.plan.push(response.data.planTimeEndStr);
          this.formData.designTypeId = JSON.parse(response.data.allDesignTypeId);
          this.formData.storageFolderId = response.data.storageFolderIds.split(',').map((item) => {
            return parseInt(item)
          });


          if (response.data.referenceFileDetail) {
            that.beforeReferenceFileDetail = JSON.parse(response.data.referenceFileDetail)
            that.beforeReferenceFileDetail.map((item) => {
              item.fileId = item.id;
              item.name = item.fileName;
              item.relativePath = item.fileName;
              item.size = item.fileSize;
              item.fileType = item.fileContentType;
            })
            that.formData.referenceFileId = that.beforeReferenceFileDetail;
          }

          if (response.data.requirementFileDetail) {
            that.beforeRequirementFileDetail = [JSON.parse(response.data.requirementFileDetail)]
            that.beforeRequirementFileDetail.map((item) => {
              item.fileId = item.id;
              item.name = item.fileName;
              item.relativePath = item.fileName;
              item.size = item.fileSize;
              item.fileType = item.fileContentType;
            })
            that.formData.requirementFileId = that.beforeRequirementFileDetail;
          }



        }
      });
    }
    this.getDepartmentFun(); //部门列表
    this.getProjectFun();// 项目列表
    this.getDesignTypeFun();//设计类型列表
    this.getOutSourceFun(this.formData.outsourcerType ? this.formData.outsourcerType : undefined);//外包商列表
  },
  methods: {
    //部门列表
    getDepartmentFun() {
      config_departmentList().then(response => {
        if (response.code == 1) {
          this.departmentOptions = response.data
        }
      })
    },

    // 项目列表
    getProjectFun() {
      projectList_ajax().then(response => {
        if (response.code == 1) {
          this.gameOptions = response.data
        }
      })
    },
    //设计类型列表
    getDesignTypeFun() {
      config_designTypeTree().then(response => {
        if (response.code == 1) {
          this.designTypeOptions = response.data
        }
      })
    },
    //外包商列表
    getOutSourceFun(type) {
      config_outsourceList(type ? type : this.formData.outsourcerType).then(response => {
        if (response.code == 1) {
          this.outsourcingOptions = response.data
        }
      })
    },


    changeOutsourcerType(value) {
      this.formData.outsourcerId = '';
      this.getOutSourceFun(this.formData.outsourcerType)
    },
    //保存
    saveFun() {

    },

    // 提交
    handleSubmit() {
      this.$refs.ruleForm.validate((valid, obj) => {
        if (valid) {
          let param = deepClone(this.formData)

          param.planTimeStartStr = param.plan[0]
          param.planTimeEndStr = param.plan[1]
          param.plan = undefined

          let tempIdArr = [];
          param.designTypeId.map((item) => {
            tempIdArr.push(item[item.length - 1]);
          })
          param.designTypeId = tempIdArr.join(',')
          param.storageFolderId = param.storageFolderId[param.storageFolderId.length - 1]

          let tempRequirementFileIdArr = []
          param.requirementFileId.map((item) => {
            tempRequirementFileIdArr.push(item.fileId)
          })
          param.requirementFileId = tempRequirementFileIdArr.join(',')

          let tempReferenceFileIdArr = []
          param.referenceFileId.map((item) => {
            tempReferenceFileIdArr.push(item.fileId)

          })
          param.referenceFileId = tempReferenceFileIdArr.join(',')


          param.createUserName = undefined;
          param.noticeType = this.checkedEmail ? 1 : 0
          param.status = 1
          if (this.flowId) {
            param.id = this.flowId
            outsource_modifyFlow(param).then(response => {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.$router.push({ path: '/outsourceTaskCenter/outsourceTaskCenter' })
            })

          } else {
            outsource_addFlow(param).then(response => {

              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.$router.push({ path: '/outsourceTaskCenter/outsourceTaskCenter' })
            })
          }

        } else {
          console.log(valid, 'valid', '====', obj, 'obj')
          this.scrollToView(this, obj)
          this.$message({ type: 'warning', message: '有必填项内容未填写' })
        }
      })

    },
    //校验滚动方法
    scrollToView(_this, object) {
      for (let i in object) {
        let dom = _this.$refs[i];
        if (Object.prototype.toString.call(dom) !== "[object Object]") {
          //这里是针对遍历的情况（多个输入框），取值为数组
          dom = dom[0];
        }
        //第一种方法（包含动画效果）
        dom.$el.scrollIntoView({
          //滚动到指定节点
          block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
          behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
        });

        //第二种方法
        // let top = dom.$el.getBoundingClientRect().top; //获取当前节点的偏移值
        // console.log(top,'top');
        // let scrollTop = document.documentElement.scrollTop; //获取视图滚动值
        // let diff = top + scrollTop;
        // document.documentElement.scrollTop = diff - 276; //276是第一个输入框节点距离顶部的偏移值，也可以在初始化提前保存
        //window.scrollTo(0,diff- 276) //同上
        break; //因为我们只需要检测一项,所以就可以跳出循环了
      }
    },

    // 重置
    handleReset() {
      this.$refs.ruleForm.resetFields();
    },

    handleSuccess(file, fileList, tag) {
      console.log(file, fileList, tag)
      this.formData[tag] = fileList
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField(tag)
      })
    },

    handleRemove(fileList, tag) {
      // item.fieldValue = fileList
      this.formData[tag] = fileList
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.app-container {
  padding: 21px 32px 0;
  min-height: calc(100vh - 50px);
  overflow: hidden;
  background: #f0f2f5;
}
.triangleClass{
    width: 240px;
    //  ::v-deep.el-icon-arrow-down:before{
    //     // content:"none";
    //     content: url('../../assets/invertTriangle.png');
    //     // position: absolute;
    //     // top: 4px;
    //     // left: -25px;
        
    // }
}
.dateClass{
    width:240px;
    height:36px;
   
    ::v-deep .el-icon-date:before{
        content:''
    }
    ::v-deep .el-input__suffix{
        .el-icon-circle-close:before {
            position: absolute !important;
            top: 0px !important;
            right: 30px !important;
            display: block;
        }
    }
    ::v-deep .el-input__suffix::after{
        content: url('../../assets/date.png');
        position: absolute;
        top: 4px;
        left: -25px;
        
    }
    ::v-deep .el-input__icon{
        width: 0 !important;
    }
     ::v-deep .el-input__inner{
        padding-left: 15px !important;
    }
}
.container-page {
  // height: calc(100vh - 71px);
  padding: 24px 24px 128px 24px;
  background: #ffffff;
  border-radius: 4px 4px 0px 0px;
  position: relative;
  .title-box {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin: 0 0 20px;
  }
  .title {
    padding-left: 12px;
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 0;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: -9px;
      left: 0;
      width: 4px;
      height: 18px;
      background: #3a89ff;
    }
  }
  .icon {
    font-size: 14px;
    margin-left: 8px;
    cursor: pointer;
  }
  .download {
    color: #3a89ff;
  }
  .form-item {
    // margin-bottom: 12px;

    ::v-deep .el-form-item__label {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }
  }
  .form-inline-item {
    display: inline-block;
    margin-right: 40px;
  }

//   ::v-deep .el-icon-arrow-up:before {
//     content: "\E78F";
//     color: #666;
//   }

  ::v-deep .el-input__inner {
    border-radius: 4px;
    border: 1px solid #e5e5e5;
  }

  ::v-deep .el-input.is-disabled .el-input__inner {
    background: #f5f5f5;
  }

  .select-item {
    display: inline-flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    width: 240px;
    height: 36px;
    padding: 0px 15px;
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    border: 1px solid #e5e5e5;
    .label,
    .text {
      display: block;
      font-size: 14px;
      color: #666666;
    }
    .label {
      margin-right: 12px;
    }
    .text {
      flex-shrink: 0;
      text-align: right;
    }
    ::v-deep .el-input__inner {
      border: 0;
      background: transparent;
      padding: 0;
      text-align: left;
      box-shadow: none;
    }
    ::v-deep .el-input-number__decrease,
    ::v-deep .el-input-number__increase {
      display: none;
    }
    ::v-deep .el-input-number--medium {
      flex-grow: 1;
      width: 50px;
      margin-left: 12px;
    }
    ::v-deep .el-select {
      flex-shrink: 0;
      width: 91px;
      border-right: 1px solid #e5e5e5;
    }
  }

  .input-item {
    ::v-deep .el-input-number {
      margin-left: 0 !important;
    }
  }

  .line {
    margin: 32px 0 32px;
    height: 1px;
    background: #eeeeee;
  }
}

.footer-box {
  position: fixed;
  left: calc(#{$sideBarWidth} + 32px);
  bottom: 0;
  width: calc(100% - #{$sideBarWidth} - 32px - 38px);
  height: 68px;
  background: #ffffff;
  box-shadow: 0px -1px 5px 0px rgba(0, 0, 0, 0.08);

  padding: 0 24px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;

  .check-box {
    margin-right: 64px;
    label {
      margin-right: 6px;
      font-size: 14px;
      color: #666666;
    }
  }
  .el-button--primary.is-plain {
    color: #3a89ff;
    border: 1px solid #3a89ff;
    background: #ffffff;
  }
  .el-button {
    padding: 10px 15px;
  }
  .el-button + .el-button {
    margin-left: 12px;
  }
}

.hideSidebar {
  .footer-box {
    width: calc(100% - 124px);
    left: 86px;
  }
}
.mobile {
  .footer-box {
    left: 32px;
    width: calc(100% - 70px);
  }
}
</style>